import { isEmpty } from 'lodash-es'

const getAbsoluteUrl = (src, siteUrl = '') => {
  if (
    /^(http(s)?)/gi.test(src) ||
    /^(data:image)/gi.test(src) ||
    isEmpty(src)
  ) {
    return src
  }

  return `${siteUrl}${src}`
}

export { getAbsoluteUrl }
